angular.module('bmsApp.directives').factory('FeedbackSvc', function ($rootScope, $http, $log, $window, $q, CRUDSvc, $modal) {
	return {
		index: function (params) {
			return CRUDSvc.post('api/feedback/index', params);
		},
		showFeedbackBreakdown: function(feedback, feedbackDates) {
			let  modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/dashboard/templates/FeedbackBreakdown.html',
				controller: 'FeedbackBreakdownCtrl',
				controllerAs: 'Feedback',
				resolve: {
					feedback: function () {
						return angular.copy(feedback);
					},
					feedbackDates: function () {
						return angular.copy(feedbackDates);
					},
				},
				size: 'md',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
			});

			return modalInstance.result;
		},
	}
});




